'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

var _handleActions;

import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import * as ActionTypes from '../actions/ActionTypes';
import FormState from 'MeetingsLib/models/FormState';
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var _action$payload = action.payload,
      formPrefills = _action$payload.bookInfo.formPrefills,
      configuredCustomFormFields = _action$payload.customFormFields;
  state = state || new FormState(); // merge fields from query params with fields saved on link
  // don't filter out fields that are not saved on link
  // support "hidden field" submissions SMMC-1144

  var _state$toObject = state.toObject(),
      customFormFields = _state$toObject.customFormFields,
      defaultFormFields = _objectWithoutProperties(_state$toObject, ["customFormFields"]);

  defaultFormFields = ImmutableMap(defaultFormFields).map(function (field, key) {
    return field || formPrefills.get(key);
  });
  customFormFields = configuredCustomFormFields.map(function (field, key) {
    return formPrefills.getIn(['customFormFields', key], field);
  }).merge(state.customFormFields);
  return state.merge(defaultFormFields).set('customFormFields', customFormFields).set('originalFormState', state.delete('originalFormState'));
}), _defineProperty(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED, function (state, action) {
  var _action$payload2 = action.payload,
      formPrefills = _action$payload2.bookInfo.formPrefills,
      configuredCustomFormFields = _action$payload2.customFormFields;

  var _state$originalFormSt = state.originalFormState.toObject(),
      customFormFields = _state$originalFormSt.customFormFields;

  return state.email !== formPrefills.email ? FormState.from({
    email: state.email,
    customFormFields: configuredCustomFormFields.merge(customFormFields)
  }) : state;
}), _handleActions), null);